import script from "./DuaTalbiya.vue?vue&type=script&setup=true&lang=js"
export * from "./DuaTalbiya.vue?vue&type=script&setup=true&lang=js"

import "./DuaTalbiya.vue?vue&type=style&index=0&id=a1fe5a5a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a1fe5a5a"]])

export default __exports__